import React from 'react';
import TablemaintDrawer from './TablemaintDrawer';
import type { CustomDrawerProps } from './TablemaintPage';
import { findTable } from '../../config/dataTables.registry';

/**
 * SCAC Location map drawer, mountable standalone.
 *
 * The Data Management page renders this table through the generic drawer directly.
 * This wrapper exists for the OTHER caller: the SCAC Info drawer opens a SCAC
 * Location from inside itself as an rpcylocations subtable row, and there the SCAC
 * and Region belong to the parent — passed as `presetValues`, which pre-fills them
 * on create and renders them read-only so they can't drift from the parent context.
 */
interface Props extends CustomDrawerProps {
  lockedScac?: string;
  lockedLocation?: string;
}

const ScacLocationMapEditDrawer: React.FC<Props> = ({ row, onClose, onSaved, lockedScac, lockedLocation }) => {
  const cfg = findTable('scaclocationmap');
  if (!cfg) return null;
  // A row from SCAC Info carries only { recno }, so let the drawer fetch the record.
  const recno = row?.recno ? Number(row.recno) : null;
  return (
    <TablemaintDrawer
      cfg={cfg}
      isOpen
      row={null}
      recno={recno}
      width="44rem"
      presetValues={lockedScac !== undefined
        ? { scac: lockedScac, location: lockedLocation ?? '' }
        : undefined}
      onClose={onClose}
      onSaved={() => onSaved()}
    />
  );
};

export default ScacLocationMapEditDrawer;
